export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <div className="border-b border-gray-100 bg-gray-50 px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-orange-500">Legal</p>
          <h1 className="text-3xl font-extrabold tracking-tight text-black sm:text-4xl">Terms of Service</h1>
          <p className="mt-3 text-sm text-gray-500">Last updated: April 2026</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="prose-style space-y-10 text-[15px] leading-relaxed text-gray-600">

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">1. Acceptance of Terms</h2>
            <p>By engaging Focus Traffic Plans Pty Ltd (ABN 23 659 805 231) ("we", "us", "our") for any service, or by accessing our website at focustrafficplans.com.au, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services or website.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">2. Services</h2>
            <p>We provide traffic management planning, traffic guidance scheme preparation, council permit assistance, pedestrian control plans, road closure and detour plans, and related traffic management consultancy services. All services are provided subject to these terms and any additional terms agreed in writing.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">3. Quotes and Pricing</h2>
            <p>All quotes provided by us are valid for 30 days from the date of issue unless otherwise stated. Prices are exclusive of GST unless expressly stated otherwise. We reserve the right to adjust pricing where the scope of works materially changes after a quote has been accepted.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">4. Payment</h2>
            <p>Payment terms are as specified in your invoice. Invoices are due within 14 days of the date of issue unless otherwise agreed in writing. We reserve the right to withhold delivery of completed plans or documents until payment has been received in full.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">5. Intellectual Property</h2>
            <p>All traffic management plans, diagrams, schemes and documents prepared by us remain the intellectual property of Focus Traffic Plans Pty Ltd until payment is received in full. Upon full payment, a licence to use the documents for the specific project for which they were prepared is granted to the client. Documents may not be reused, modified or on-sold without our written consent.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">6. Client Responsibilities</h2>
            <p>You are responsible for providing accurate and complete project information. We will not be held liable for errors, delays or costs arising from incomplete or incorrect information provided by you or a third party on your behalf. It is your responsibility to ensure that all plans are implemented correctly on site in accordance with the documentation provided.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">7. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, our total liability to you for any claim arising out of or in connection with our services is limited to the fees paid by you for the specific service giving rise to the claim. We are not liable for any indirect, consequential, special or incidental loss or damage.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">8. Compliance</h2>
            <p>Our plans and documents are prepared in good faith in accordance with relevant Australian Standards, Transport for NSW guidelines and local authority requirements current at the time of preparation. We cannot guarantee that every authority will approve every submission, as approval decisions rest with the relevant authority.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">9. Termination</h2>
            <p>Either party may terminate an engagement by providing written notice. Where we have commenced work, you will be invoiced for work completed to the date of termination at our standard hourly rate or as otherwise agreed.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">10. Governing Law</h2>
            <p>These terms are governed by the laws of New South Wales, Australia. Any dispute arising from these terms shall be subject to the exclusive jurisdiction of the courts of New South Wales.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">11. Contact</h2>
            <p>If you have any questions about these Terms of Service, please contact us at <a href="mailto:info@focustrafficplans.com.au" className="text-orange-500 underline">info@focustrafficplans.com.au</a> or call <a href="tel:1300118170" className="text-orange-500 underline">1300 118 170</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
